import React, { useEffect, useMemo } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionSujetoExcluidoSucursal} from '../../../../actions/action-creators'
import {isNullOrEmpty} from '../../../../utils/strings.utils'
import { encontrarSerieActiva, encontrarSucursalConDocs } from '../../../../utils/invoice/sucursales_docs'
import { sujetoExcluidoClearAll, sujetoExcluidoSetCatalogoSerie } from '../../../../actions/sujeto-excluido/sujetoExcluidoEmision.actions'
import { sujetoExcluidoFormSucursalHandleChange } from '../../../../actions/sujeto-excluido/sujetoExcluidoSucursal.actions'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import { showMessageSucursalVacia } from '../../../../actions/userLogin.actions'
import { useHistory } from 'react-router-dom'

const SEDatosSucursal = () => {
  const history = useHistory();
  const {activeDoc} = useSelector((state: State) => state.documentos)
  const {sucursalesCargadas} = useSelector((state: State) => state.sujetoExcluido)
  const sucursales = useSelector((state: State) => state.sujetoExcluido.catalogoSucursal)
  const series = useSelector((state: State) => state.sujetoExcluido.catalogoSerie)
  const form = useSelector((state: State) => state.sujetoExcluido.formSucursal)
  const errors = useSelector((state: State) => state.sujetoExcluido.errorsFormSucursal)
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionSujetoExcluidoSucursal, dispatch)

  useEffect(() => {
    if (sucursales.length > 0) {
      try {
        const sucursalDefault = sucursales[0];
        const serieDefault = sucursalDefault?.Documento[0];
        
        if (sucursalDefault && serieDefault) {
          dispatch(sujetoExcluidoSetCatalogoSerie(sucursalDefault.Documento));
          dispatch(sujetoExcluidoFormSucursalHandleChange({
            'sucursal': sucursalDefault.idsucursal,
            'serie': serieDefault.idsucursaldocumento,
            'datosSerie': serieDefault,
          }));
        } else {
          dispatch(sujetoExcluidoFormSucursalHandleChange({
            'sucursal': '',
            'serie': '',
          }));
        }
      } catch(e) {}
    } else {
      if (sucursalesCargadas) {
        dispatch(showMessageSucursalVacia('Factura de sujeto excluido'));
        history.push('/otros-documentos');
        dispatch(sujetoExcluidoClearAll());
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sucursales]);

  return (
    <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc' style={{marginBottom: '5%'}} >
      <div>
        <h3 className='card-title l'>Sucursal y Serie</h3>
      </div>
      <div className='form-separator'></div>
      <div className='w-layout-hflex h-inputs'>
        <div className='label-input'>
          <label htmlFor='sucursal' className='field-label m'>
            Sucursal<span style={{color: 'red'}}>*</span>
          </label>
          <SearchSelect disabled={true} defaultValue={null} data={sucursales} value={form.sucursal} keyNameText='nombre' keyNameValue='idsucursal' placeholder='Sucursal' name='sucursal' onChange={(value: any) => {acciones.sujetoExcluidoFormSucursalHandleChangeInput({target: {value: value?.value, name: 'sucursal'}}) ; acciones.sujetoExcluidoFormSucursalOnBlur({target: {value: value?.value, name: 'sucursal'}})}}/>
          {errors.sucursal && <p className='alert s'>{errors.sucursal}</p>}
        </div>
        <div className='label-input'>
          <label htmlFor='serie' className='field-label m'>
            Serie<span style={{color: 'red'}}>*</span>
          </label>
          <SearchSelect disabled={!sucursalesCargadas} defaultValue={null} data={series.map((serie) => {return({...serie, serie_numero: `${serie?.serie}-${serie?.numeroactual}`})})} value={form.serie} keyNameText='serie_numero' keyNameValue='idsucursaldocumento' placeholder='Serie' name='serie' onChange={(value: any) => {acciones.sujetoExcluidoFormSucursalHandleChangeInput({target: {value: value?.value, name: 'serie'}}) ; acciones.sujetoExcluidoFormSucursalOnBlur({target: {value: value?.value, name: 'serie'}})}}/>
          {errors.serie && <p className='alert s'>{errors.serie}</p>}
        </div>
      </div>
      <div className='separador'></div>
    </form>
  )
}

export default SEDatosSucursal
